// Итоги дня на таймлайне: залог и приход по одной брони.
//
// Вынесено из TimelineCalendar.vue по итогам холистического ревью 2026-08-24.
// Причина не в красоте: обе формулы жили внутри computed-свойств компонента и
// не были покрыты ничем — ревьюер выкинул из суммы слагаемое `fine` и откатил
// выбор поля залога, и весь юнит-сюит (1708 тестов) остался зелёным. Здесь они
// доступны прямому тесту, как арифметика допов в addonsMath.js.
import { bookingDeposit } from "@/components/dashboard/bookings/addonsMath";

// Реэкспорт: канон выбора поля залога живёт в addonsMath рядом с
// depositFieldFor, потому что им пользуются не только итоги таймлайна, но и
// попапы календарей. Здесь — точка входа для спеки итогов.
export { bookingDeposit };

// ВНИМАНИЕ: порядок слагаемых менять нельзя. Он воспроизводит легаси-формулу
// дословно, и это проверено фаззингом (200k случаев, ноль расхождений).
// Перестановка не эквивалентна дважды: на строковом поле `+` конкатенирует
// (очищенный money-инпут даёт "" — задокументированный класс, moneySum.js), а
// на дробных числах меняется последний разряд, и он виден на экране, потому
// что итог рендерится без округления.
//
// Единственное различие между типами, помимо поля залога, — доплата за часы:
// у почасовой брони hours_cost/hours_cost_end в сумму не входят.
export function bookingIncome(booking) {
  const deposit = bookingDeposit(booking);
  if (!booking.hourly) {
    return (
      booking.rental_cost +
      booking.delivery +
      booking.delivery_end +
      booking.equipment +
      (booking.addons_cost || 0) + // FT-102 REQ-07
      booking.insurance +
      booking.clean_payment +
      booking.add_drivers_cost +
      booking.hours_cost +
      booking.mileage_cost +
      booking.damage +
      booking.gas +
      booking.fine +
      booking.other +
      booking.other_end +
      booking.hours_cost_end +
      deposit
    );
  }
  return (
    booking.rental_cost +
    booking.delivery +
    booking.delivery_end +
    booking.equipment +
    (booking.addons_cost || 0) + // FT-102 REQ-07
    booking.insurance +
    booking.clean_payment +
    booking.add_drivers_cost +
    booking.mileage_cost +
    booking.damage +
    booking.gas +
    booking.fine +
    booking.other +
    booking.other_end +
    deposit
  );
}
